<!-- Contract Card Template (for mobile view) -->
<ng-template
	#contractCardTemplate
	let-row>
	<div class="eif-card">
		<div class="eif-card-header">
			<div class="label">
				{{ 'invitation-screen.contract' | translate }}
			</div>
			<div class="is-bold">{{ row.externalContractId }}</div>
			<span>{{ 'invitation-screen.confirming' | translate }}</span>
		</div>
		<div class="eif-card-section">
			<div class="label">
				{{ 'invitation-screen.currency' | translate }}
			</div>
			<div class="is-bold text-uppercase">{{ row.currency }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">
				{{ 'invitation-screen.financier' | translate }}
			</div>
			<div class="text-truncate">{{ row.financierName }}</div>
			<span>{{ row.financierCountry }} {{ row.financierVat }}</span>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'invitation-screen.iban' | translate }}</div>
			<div class="text-truncate">{{ row.iban }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'invitation-screen.swift' | translate }}</div>
			<div>{{ row.swift }}</div>
		</div>
	</div>
</ng-template>

<ng-template #passwordTooltip>
	<div class="password-tooltip">
		<div class="is-bold">{{ 'resetPassword.passwordRules' | translate: 'client' : pageDisplayLanguageCode }}</div>
		<ul>
			<li>{{ 'resetPassword.passwordRule1' | translate: 'client' : pageDisplayLanguageCode }}</li>
			<li>{{ 'resetPassword.passwordRule2' | translate: 'client' : pageDisplayLanguageCode }}</li>
			<li>{{ 'resetPassword.passwordRule3' | translate: 'client' : pageDisplayLanguageCode }}</li>
			<li>{{ 'resetPassword.passwordRule4' | translate: 'client' : pageDisplayLanguageCode }}</li>
			<li>{{ 'resetPassword.passwordRule5' | translate: 'client' : pageDisplayLanguageCode }}</li>
		</ul>
	</div>
</ng-template>

<div class="public-bg">
	<div class="public-content">
		<div class="public-app-logo">
			<img
				src="assets/images/logo-flexcash-white.png"
				alt="App-Logo"
				class="is-logo-white" />
		</div>

		<div
			class="invitation-wrapper"
			[class.has-form]="!token.expired && !token.used && !showSucessSubmission">
			@if (!showSucessSubmission) {
				<div class="welcome-container">
					<h2 class="welcome-title mb-4">
						{{ 'invitation-screen.welcome-header' | translate: 'client' : pageDisplayLanguageCode }}
					</h2>
					<p class="welcome-user">
						{{ invitedUserIdentification }}
					</p>
					<p [innerHTML]="invitationCompaniesIdentification"></p>
				</div>
			}

			@if (token.expired) {
				<eif-invitation-submission
					[content]="token.expiredContent"
					[icon]="'fa-solid fa-mail-bulk'"
					[buttonText]="'invitation-screen.button.login' | translate: 'client' : pageDisplayLanguageCode"
					[route]="'/public/login'">
				</eif-invitation-submission>
			}

			@if (token.used) {
				<eif-invitation-submission
					[content]="token.usedContent"
					[icon]="'fa-solid fa-mail-bulk'"
					[buttonText]="'invitation-screen.button.login' | translate: 'client' : pageDisplayLanguageCode"
					[route]="'/public/login'">
				</eif-invitation-submission>
			}

			@if (showSucessSubmission) {
				<eif-invitation-submission
					[content]="sucessSubmissionContent"
					[icon]="'fa-solid fa-paper-plane'"
					[buttonText]="'invitation-screen.button.login' | translate: 'client' : pageDisplayLanguageCode"
					[route]="'/public/login'">
				</eif-invitation-submission>
			}

			@if (!token.expired && !token.used) {
				<form
					#form="ngForm"
					name="ngForm"
					class="invitation-form"
					[class.form-hidden]="showSucessSubmission">
					@if (invitationScreenType !== 'user') {
						<div class="simple-card invitation-form-section">
							<p class="invitation-form-section-title is-main-value is-one-column">
								{{ 'invitation-screen.company.title' | translate: 'client' : pageDisplayLanguageCode }}
							</p>
							<eif-custom-input
								#countryCodeInput
								[(ngModel)]="invitedCompany.CountryCode"
								[name]="'invitedCompany.CountryCode'"
								[label]="'invitation-screen.countryCode' | translate: 'client' : pageDisplayLanguageCode"
								[readonlyValue]="true"
								[autoHeight]="true"
								[class]="'is-highlight-section is-read-only'">
							</eif-custom-input>
							<eif-custom-input
								#vatNumberInput
								[(ngModel)]="invitedCompany.VatNumber"
								[name]="'invitedCompany.VatNumber'"
								[label]="'invitation-screen.vatNumber' | translate: 'client' : pageDisplayLanguageCode"
								[readonlyValue]="true"
								[autoHeight]="true"
								[class]="'is-highlight-section is-read-only'">
							</eif-custom-input>
							<eif-custom-input
								#companyNameInput
								[(ngModel)]="invitedCompany.Name"
								[name]="'invitedCompany.Name'"
								[label]="'invitation-screen.name' | translate: 'client' : pageDisplayLanguageCode"
								[validationRules]="getValidationRules('companyName')"
								(valueChange)="onValueChange('companyName', $event)"
								(validationChange)="onValidationChange('companyName', $event)">
							</eif-custom-input>
							<eif-custom-input
								#companyAddressLine1Input
								[(ngModel)]="invitedCompany.AddressLine1"
								[name]="'invitedCompany.AddressLine1'"
								[label]="'invitation-screen.address.line1' | translate: 'client' : pageDisplayLanguageCode"
								[validationRules]="getValidationRules('companyAddressLine1')"
								(valueChange)="onValueChange('companyAddressLine1', $event)"
								(validationChange)="onValidationChange('companyAddressLine1', $event)">
							</eif-custom-input>
							<eif-custom-input
								#companyAddressLine2Input
								[(ngModel)]="invitedCompany.AddressLine2"
								[name]="'invitedCompany.AddressLine2'"
								[label]="'invitation-screen.address.line2' | translate: 'client' : pageDisplayLanguageCode"
								(valueChange)="onValueChange('companyAddressLine2', $event)">
							</eif-custom-input>
							<eif-custom-input
								#companyAddressLine3Input
								[(ngModel)]="invitedCompany.AddressLine3"
								[name]="'invitedCompany.AddressLine3'"
								[label]="'invitation-screen.address.line3' | translate: 'client' : pageDisplayLanguageCode"
								(valueChange)="onValueChange('companyAddressLine3', $event)">
							</eif-custom-input>
							<eif-custom-input
								#companyZipCodeInput
								[(ngModel)]="invitedCompany.ZipCode"
								[name]="'invitedCompany.ZipCode'"
								[label]="'invitation-screen.zipCode' | translate: 'client' : pageDisplayLanguageCode"
								[validationRules]="getValidationRules('companyZipCode')"
								(valueChange)="onValueChange('companyZipCode', $event)"
								(validationChange)="onValidationChange('companyZipCode', $event)">
							</eif-custom-input>
							<eif-custom-input
								#companyCityInput
								[(ngModel)]="invitedCompany.City"
								[name]="'invitedCompany.City'"
								[label]="'invitation-screen.city' | translate: 'client' : pageDisplayLanguageCode"
								[validationRules]="getValidationRules('companyCity')"
								(valueChange)="onValueChange('companyCity', $event)"
								(validationChange)="onValidationChange('companyCity', $event)">
							</eif-custom-input>
							<eif-custom-select
								#companyTimeZoneSelect
								[label]="'invitation-screen.timeZone' | translate: 'client' : pageDisplayLanguageCode"
								[options]="timeZoneOptions"
								[value]="invitedCompany.TimeZone"
								[name]="'timeZone'"
								(selectionChange)="onTimeZoneSelectionChange($event)"
								[concatOptions]="true"
								[validationRules]="getValidationRules('companyTimeZone')"
								(valueChange)="onValueChange('companyTimeZone', $event)"
								(validationChange)="onValidationChange('companyTimeZone', $event)"
								[fullWidth]="true">
							</eif-custom-select>
							<eif-custom-select
								#companyLanguageCodeSelect
								[label]="'invitation-screen.languageCode' | translate: 'client' : pageDisplayLanguageCode"
								[options]="languageCodeOptions"
								[value]="invitedCompany.LanguageCode"
								[name]="'languageCode'"
								(selectionChange)="onLanguageCodeSelectionChange($event)"
								[concatOptions]="true"
								[validationRules]="getValidationRules('companyLanguageCode')"
								(valueChange)="onValueChange('companyLanguageCode', $event)"
								(validationChange)="onValidationChange('companyLanguageCode', $event)"
								[fullWidth]="true">
							</eif-custom-select>
							<eif-custom-input
								#companyShareCapitalInput
								[label]="'invitation-screen.shareCapital' | translate: 'client' : pageDisplayLanguageCode"
								[ngModel]="invitedCompany.ShareCapital | currencyFormatter"
								(ngModelChange)="
									invitedCompany.ShareCapital = utilitiesService.TransformFromPipedValue($event);
									onValueChange('companyShareCapital', $event)
								"
								[name]="'invitedCompanyShareCapital'"
								[validationRules]="getValidationRules('companyShareCapital')"
								(validationChange)="onValidationChange('companyShareCapital', $event)"
								(keypress)="validateOnlyNumbers($event)">
							</eif-custom-input>
						</div>
					}
					<!-- Contract Information Section (only for supplierConfirming) -->
					@if (invitationScreenType === 'supplierConfirming' && contractData) {
						<div class="simple-card invitation-form-section">
							<p class="invitation-form-section-title is-main-value is-one-column">
								{{ 'invitation-screen.contract.title' | translate: 'client' : pageDisplayLanguageCode }}
							</p>
							<div class="contract-table-wrapper">
								<eif-custom-table
									[columns]="contractTableColumns"
									[rows]="contractTableRows"
									[selectionMode]="'none'"
									[enableFilters]="false"
									[showPagination]="false"
									[cardTemplate]="contractCardTemplate">
								</eif-custom-table>
							</div>
						</div>
					}
					<div
						class="simple-card invitation-form-section"
						[ngClass]="{ 'is-user-only': invitationScreenType === 'user' }">
						<p class="invitation-form-section-title is-main-value is-one-column">
							{{
								(invitationScreenType === 'user' ? 'invitation-screen.user.titleRegistration' : 'invitation-screen.user.title')
									| translate: 'client' : pageDisplayLanguageCode
							}}
						</p>
						<eif-custom-input
							#usernameInput
							[label]="'invitation-screen.username' | translate: 'client' : pageDisplayLanguageCode"
							[ngModel]="registerUserInput.Email"
							[name]="'registerUserInputUsername'"
							[readonlyValue]="true"
							[required]="true"
							[autoHeight]="true"
							[class]="'is-highlight-section is-read-only'">
						</eif-custom-input>
						<eif-custom-input
							#emailInput
							[label]="'invitation-screen.email' | translate: 'client' : pageDisplayLanguageCode"
							[(ngModel)]="registerUserInput.Email"
							[name]="'registerUserInputEmail'"
							[readonlyValue]="true"
							[required]="true"
							[autoHeight]="true"
							[class]="'is-highlight-section is-read-only'">
						</eif-custom-input>
						<eif-custom-input
							#userNameInput
							[label]="'invitation-screen.name' | translate: 'client' : pageDisplayLanguageCode"
							[(ngModel)]="registerUserInput.Name"
							[name]="'registerUserInputName'"
							[validationRules]="getValidationRules('userName')"
							(valueChange)="onValueChange('userName', $event)"
							(validationChange)="onValidationChange('userName', $event)"
							[hidden]="!newUser">
						</eif-custom-input>
						<eif-custom-input
							#userTelephoneInput
							[label]="'invitation-screen.telephone' | translate: 'client' : pageDisplayLanguageCode"
							[(ngModel)]="registerUserInput.Telephone"
							[name]="'registerUserInputTelephone'"
							[validationRules]="getValidationRules('userTelephone')"
							(valueChange)="onValueChange('userTelephone', $event)"
							(validationChange)="onValidationChange('userTelephone', $event)"
							[hidden]="!newUser">
						</eif-custom-input>
						<eif-custom-input
							#userPasswordInput
							[label]="'invitation-screen.password' | translate: 'client' : pageDisplayLanguageCode"
							[(ngModel)]="registerUserInput.Pawd"
							[name]="'registerUserInputPassword'"
							[type]="'password'"
							[autoComplete]="'new-password'"
							[icon]="'fa-solid fa-info-circle'"
							[tooltip]="passwordTooltip"
							[validationRules]="passwordValidationRules"
							(valueChange)="onPasswordChange($event)"
							(validationChange)="onValidationChange('userPassword', $event)"
							[hidden]="!newUser">
						</eif-custom-input>
						<eif-custom-input
							#userRepeatPasswordInput
							[label]="'invitation-screen.repeatPassword' | translate: 'client' : pageDisplayLanguageCode"
							[(ngModel)]="registerUserInput.RepeatePawd"
							[name]="'registerUserInputRepeatePassword'"
							[type]="'password'"
							[autoComplete]="'new-password'"
							[validationRules]="repeatPasswordValidationRules"
							(valueChange)="onRepeatPasswordChange($event)"
							(validationChange)="onValidationChange('userRepeatPassword', $event)"
							[hidden]="!newUser">
						</eif-custom-input>
						<eif-custom-select
							#userLanguageCodeSelect
							[label]="'invitation-screen.languageCode' | translate: 'client' : pageDisplayLanguageCode"
							[options]="userLanguageCodeOptions"
							[value]="registerUserInput.LanguageCode"
							[name]="'registerUserInputLanguageCode'"
							(selectionChange)="onUserLanguageCodeSelectionChange($event)"
							[concatOptions]="true"
							[validationRules]="getValidationRules('userLanguageCode')"
							(valueChange)="onValueChange('userLanguageCode', $event)"
							(validationChange)="onValidationChange('userLanguageCode', $event)"
							[hidden]="!newUser"
							[fullWidth]="true">
						</eif-custom-select>
						<eif-custom-select
							#userTimeZoneSelect
							[label]="'invitation-screen.timeZone' | translate: 'client' : pageDisplayLanguageCode"
							[options]="userTimeZoneOptions"
							[value]="registerUserInput.TimeZone"
							[name]="'registerUserInputTimeZone'"
							(selectionChange)="onUserTimeZoneSelectionChange($event)"
							[concatOptions]="true"
							[validationRules]="getValidationRules('userTimeZone')"
							(valueChange)="onValueChange('userTimeZone', $event)"
							(validationChange)="onValidationChange('userTimeZone', $event)"
							[hidden]="!newUser"
							[fullWidth]="true">
						</eif-custom-select>
						<hr class="mt-3" />
						<eif-custom-checkbox
							#contractAcceptedCheckbox
							[(ngModel)]="isContractAccepted"
							[name]="'contractAccepted'"
							[class]="'invitation-checkbox'"
							[validationRules]="getValidationRules('contractAccepted')"
							(checkedChange)="onValueChange('contractAccepted', $event)"
							(validationChange)="onValidationChange('contractAccepted', $event)">
							<span>
								{{ textTolinkWithContract }}
								<a
									class="is-link"
									id="contractLink"
									(click)="openContract()">
									{{ viewContract }}
								</a>
							</span>
						</eif-custom-checkbox>
						<eif-custom-checkbox
							#personalDataAcceptedCheckbox
							[(ngModel)]="isPersonalDataConsentDocumentAccepted"
							[name]="'personalDataAccepted'"
							[class]="'invitation-checkbox'"
							[validationRules]="getValidationRules('personalDataAccepted')"
							(checkedChange)="onValueChange('personalDataAccepted', $event)"
							(validationChange)="onValidationChange('personalDataAccepted', $event)">
							<span>
								{{ textTolinkWithPersonalDataConsentDocument }}
								<a
									class="is-link"
									id="contractLink"
									(click)="openPersonalDataConsentDocument()">
									{{ viewPersonalDataConsentDocument }}
								</a>
								{{ textTolinkWithPersonalDataConsentDocumentPart2 }}
							</span>
						</eif-custom-checkbox>
					</div>
					<div class="invitation-actions">
						<eif-custom-button
							[type]="'submit'"
							[color]="'neutral'"
							[text]="'button.refuse' | translate"
							[loading]="isSubmittingRefuse"
							[disabled]="isSubmittingAccept || isSubmittingRefuse"
							(click)="onRefuseInvitation()">
						</eif-custom-button>
						<eif-custom-button
							[type]="'submit'"
							[text]="'button.accept' | translate"
							[loading]="isSubmittingAccept || isFetchingDocuments"
							[disabled]="isAcceptDisabled"
							(click)="onAcceptInvitation()">
						</eif-custom-button>
					</div>
				</form>
			}
		</div>
	</div>

	<eif-copyright></eif-copyright>
</div>
